import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link, useLocation, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import LlmAccessPage from './pages/LlmAccessPage';
import DocsPage from './pages/DocsPage';
import LoginPage from './pages/LoginPage';
import ThankYouPage from './pages/ThankYouPage';
import RegisterPage from './pages/RegisterPage';
import ProfileLayout from './pages/ProfileLayout';
import ApiKeysPage from './pages/profile/ApiKeysPage';
import BillingPage from './pages/profile/BillingPage';
import UsagePage from './pages/profile/UsagePage';
import FinancePage from './pages/profile/FinancePage';
import DevOpsPage from './pages/profile/DevOpsPage';
import { FeatureFlagProvider, useFeatureFlags } from './context/FeatureFlagContext';
import { usePageTracking } from './hooks/usePageTracking';
import { WaitlistProvider } from './context/WaitlistContext';

const AppShell: React.FC = () => {
  usePageTracking();
  const { isFeatureEnabled } = useFeatureFlags();
  const location = useLocation();
  const hideNavigation =
    location.pathname === "/" ||
    location.pathname === "/login" ||
    location.pathname === "/register" ||
    location.pathname === "/verify-email" ||
    location.pathname.startsWith("/profile") ||
    location.pathname.startsWith("/docs") ||
    location.pathname === "/thanks";

  return (
    <>
      {!hideNavigation && (
        <nav className="bg-gray-900/90 backdrop-blur">
          <div className="container mx-auto flex items-center justify-between px-4 py-4">
            <Link to="/" className="flex items-center gap-3 text-white transition hover:opacity-90">
              <span className="relative flex h-10 w-10 items-center justify-center rounded-2xl bg-gradient-to-br from-emerald-400 via-teal-500 to-sky-500 text-lg font-bold text-gray-900 shadow-lg shadow-emerald-500/40">
                <span className="absolute inset-0 rounded-2xl border border-white/40"></span>
                SL
              </span>
              <div className="flex flex-col leading-tight">
                <span className="text-sm font-semibold uppercase tracking-[0.3em] text-emerald-200">Sig</span>
                <span className="text-xl font-bold">LLM</span>
              </div>
            </Link>
            <div className="flex items-center gap-4 text-sm sm:text-base">
              <Link to="/login" className="text-white">Log in</Link>
              {isFeatureEnabled("ENABLE_REGISTRATION") && (
                <Link to="/register" className="text-white">Join</Link>
              )}
            </div>
          </div>
        </nav>
      )}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/profile" element={<ProfileLayout />}>
          <Route index element={<Navigate to="api-keys" replace />} />
          <Route path="api-keys" element={<ApiKeysPage />} />
          <Route path="billing" element={<BillingPage />} />
          <Route path="usage" element={<UsagePage />} />
          <Route path="finance" element={<FinancePage />} />
          <Route path="devops" element={<DevOpsPage />} />
        </Route>
        <Route path="/llm" element={<LlmAccessPage />} />
        <Route path="/docs/*" element={<DocsPage />} />
        <Route path="/thanks" element={<ThankYouPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/register"
          element={
            isFeatureEnabled("ENABLE_REGISTRATION") ? (
              <RegisterPage />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </>
  );
};

function App() {
  return (
    <FeatureFlagProvider>
      <Router>
        <WaitlistProvider>
          <AppShell />
        </WaitlistProvider>
      </Router>
    </FeatureFlagProvider>
  );
}

export default App;
